/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
// import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

const report = {
  // async printUnix(date) {
  //   return await helper.call('reports.unix', {
  //     // ...params
  //   }, async () => await axios(helper.path('reports/unix'), {
  //     params: {
  //       date: date ? moment(date).format('YYYY-MM-DD hh:mm:ss') : undefined,
  //     },
  //   }));
  // },
  // async printAllSales(date) {
  //   return await helper.call('reports.allsales', {
  //     // ...params
  //   }, async () => await axios(helper.path('reports/allsales'), {
  //     params: {
  //       date: date ? moment(date).format('YYYY-MM-DD hh:mm:ss') : undefined,
  //     },
  //   }));
  // },
  // async printAllSalesAndComm(userId, date) {
  //   return await helper.call('reports.sr', {
  //     // ...params
  //   }, async () => await axios(helper.path(`reports/sr/${userId}`), {
  //     params: {
  //       date: date ? moment(date).format('YYYY-MM-DD hh:mm:ss') : undefined,
  //     },
  //   }));
  // },

  // pdf
  unixReportURL(date) {
    let url = helper.path('reports/unix');
    if (date) {
      url += `?date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`;
    }
    return url;
  },
  salesReportURL(date, filterStatus) {
    let url = helper.path('reports/area'); // TODO: change to the real url
    if (date || filterStatus) {
      const params = [];

      if (date) {
        params.push(`date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`);
      }
      if (filterStatus) {
        params.push(`status=${filterStatus}`);
      }

      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }
    }
    return url;
  },
  salesAndCommReportURL(userId, date) {
    // let url = userId ? helper.path(`reports/sr/${userId}`) : helper.path('reports/allsales');
    // if (date) {
    //   url += `?date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`;
    // }
    // return url;
    let URL = '';
    console.log(userId);
    if (userId.length > 0) {
      // const usersArg = 'users[]=1&users[]=2&users[]=5';
      const usersArg = userId.reduce((prev, cur, i) => {
        if (i > 0) {
          return `${prev}&users[]=${cur}`;
        }
        return `users[]=${cur}`;
      }, `users[]=${userId[0]}`);
      console.log(userId);
      console.log(usersArg);
      URL = helper.path(`reports/sr?${usersArg}`);
    } else {
      URL = helper.path('reports/allsales?');
    }
    if (date) {
      URL += `&date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`;
    }
    return URL;
  },

  // excel
  unixExcelURL(date) {
    let url = helper.path('reports/unix/xls');
    if (date) {
      url += `?date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`;
    }
    return url;
  },
  salesExcelURL(date, filterStatus) {
    let url = helper.path('reports/area/xls'); // TODO: change to the real url
    if (date || filterStatus) {
      const params = [];

      if (date) {
        params.push(`date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`);
      }
      if (filterStatus) {
        params.push(`status=${filterStatus}`);
      }

      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }
    }
    return url;
  },
  salesAndCommExcelURL(userId, date) {
    let url = userId ? helper.path(`reports/sr/${userId}/xls`) : helper.path('reports/allsales/xls');
    if (date) {
      url += `?date=${moment(date).format('YYYY-MM-DD%20hh:mm:ss')}`;
    }
    return url;
  },
};

export default report;
